import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import SidebarSolicitante from '../Components/Sidebar/Sidebar';
import api from '../apiClient';

import '../theme/solicitante-theme.css';
import './historicoSati.css';
import { ChamadoPageSolicitante } from '../../App/Chamado';
import ListaAnexosSolicitante from '../Components/ListaAnexos/listaAnexos';
import ChamadoAttachmentField from '../NovaSati/components/ChamadoAttachmentField';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoTokenSolicitante from '../../FuncoesGerais/VerificarTokenSolicitante';

function HistoricoSatiSolicitante(props) {
    const history = useHistory();
    const id = props.match.params.id;

    const verificar = async () => {
        const resultado = await verificandoApp("SOLICITANTE");
        if (!resultado) {
            history.push("/");
            return;
        }
        await verificandoTokenSolicitante(history);
    };

    const [data, setData] = useState([]);
    const [satDesHis, setSatDesHis] = useState('');
    const [, setSatNum] = useState(0);
    const [satDesSol, setSatDesSol] = useState('');
    const [statusNome, setStatusNome] = useState('');
    const [atendenteNome, setAtendenteNome] = useState('');
    const [tipoNome, setTipoNome] = useState('');
    const [prazoEmHoras, setPrazoEmHoras] = useState(null);
    const [dataAberturaSati, setDataAberturaSati] = useState(null);

    const [anexos, setAnexos] = useState([]);
    const [novoAnexoBase64, setNovoAnexoBase64] = useState('');
    const [novoAnexoNome, setNovoAnexoNome] = useState('');
    const [salvandoAnexo, setSalvandoAnexo] = useState(false);
    const anexosCardRef = useRef(null);

    const fetchData = async () => {
        try {
            const response = await api.post('/api/conHistoricoSATI', { satNum: id });
            const lista = Array.isArray(response.data) ? response.data : [];
            setData(lista.map((item) => ({
                descricao: item.SATDESSLI,
                data: item.SATDATFEC,
                autor_nome: item.autor_nome || null,
            })));
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const fetchAnexos = async () => {
        if (!id) return;
        try {
            const response = await api.post('/api/satAnexos', { satNum: id });
            const lista = Array.isArray(response.data) ? response.data : [];
            setAnexos(lista.map((item) => ({
                satNum: item.SATNUM ?? item.satNum,
                seqAne: item.SEQANE ?? item.seqAne,
                nomArq: item.NOMARQ ?? item.nomArq,
                arquivo: item.ARQUIVO ?? item.arquivo ?? item.Arquivo64,
            })));
        } catch (err) {
            console.error('Erro ao buscar anexos:', err);
            setAnexos([]);
        }
    };

    const sadDesSolGet = async () => {
        if (!id) return;
        try {
            const response = await api.post('/api/satComp', { satNum: id });
            if (response.data && response.data[0] && response.data[0].SATNUM > 0) {
                const row = response.data[0];
                setSatDesSol(row.SATDESSOL ?? '');
                const rawStatus = (row.status_nome ?? '').toString().trim();
                setStatusNome(rawStatus && !/^\d+$/.test(rawStatus) ? rawStatus : '—');
                setAtendenteNome((row.atendente_nome ?? '').toString().trim());
                setTipoNome(row.tipo_nome ?? '');
                setPrazoEmHoras(row.prazo_em_horas != null ? Number(row.prazo_em_horas) : null);
                setDataAberturaSati(row.SATDATSOL ?? null);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const updateSatiHistorico = async (e) => {
        e.preventDefault();
        const desSli = (satDesHis || '').trim();
        if (desSli.length === 0) {
            alert('Favor preencher o trâmite!');
            return;
        }
        try {
            const codUsu = localStorage.getItem('codUsu');
            await api.put('/api/updateSATIHISTORICO', { satNum: id, desSli, codUsu });
            setSatDesHis('');
            fetchData();
        } catch (error) {
            console.error('Erro ao inserir dados:', error);
            alert('Erro ao enviar trâmite. Tente novamente.');
        }
    };

    const adicionarAnexoNoCard = async () => {
        if (!id || !novoAnexoBase64 || !novoAnexoNome?.trim()) return;
        setSalvandoAnexo(true);
        try {
            await api.post('/api/inserirAnexo', {
                satNum: id,
                nomArq: novoAnexoNome.trim(),
                Arquivo64: novoAnexoBase64,
            });
            setNovoAnexoBase64('');
            setNovoAnexoNome('');
            fetchAnexos();
            fetchData();
        } catch (err) {
            console.error('Erro ao adicionar anexo:', err);
            alert(err.response?.data?.message || 'Erro ao gravar anexo. Tente novamente.');
        } finally {
            setSalvandoAnexo(false);
        }
    };

    const openAnexo = () => {
        anexosCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {
        verificar();
        setSatNum(id);
        fetchData();
        sadDesSolGet();
        fetchAnexos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const timelineEventos = data.map((item) => ({
        descricao: item.descricao,
        data: item.data,
        autor_nome: item.autor_nome,
    }));

    const descriptionContent = (
        <>
            {(tipoNome || prazoEmHoras != null) && (
                <div className="historico-sati-sla-card historico-sati-sla-card-solicitante historico-sati-sla-discreto mb-3">
                    {tipoNome && <div className="historico-sati-sla-info"><strong>Tipo:</strong> {tipoNome}</div>}
                    {prazoEmHoras != null && dataAberturaSati && (() => {
                        const abertura = new Date(dataAberturaSati).getTime();
                        const agora = Date.now();
                        const prazoMs = prazoEmHoras * 3600 * 1000;
                        const decorrido = Math.max(0, agora - abertura);
                        const percent = Math.min(100, (decorrido / prazoMs) * 100);
                        const classe = percent < 60 ? 'sla-verde' : percent < 90 ? 'sla-amarelo' : 'sla-vermelho';
                        return (
                            <div className="historico-sati-sla-barra-wrap">
                                <div className={`historico-sati-sla-barra ${classe}`} style={{ width: `${Math.min(100, percent)}%` }} title={`${percent.toFixed(0)}% do prazo`} />
                                <span className="historico-sati-sla-barra-label">{percent < 60 ? 'No prazo' : percent < 90 ? 'Atenção' : 'SLA em risco'}</span>
                            </div>
                        );
                    })()}
                    {prazoEmHoras == null && tipoNome && <p className="historico-sati-sla-sem-prazo text-muted small mb-0">Sem prazo definido para este tipo.</p>}
                </div>
            )}
            <textarea readOnly value={satDesSol} className="form-control historico-sati-textarea-grande" rows={6} placeholder="Descrição do chamado..." />
        </>
    );

    const anexosCardContent = (
        <>
            <h4 className="chamado-sidebar-card-titulo">
                <i className="fas fa-paperclip me-2" aria-hidden="true" />
                Anexos {anexos.length > 0 && `(${anexos.length})`}
            </h4>
            {anexos.length === 0 ? (
                <p className="chamado-sidebar-anexos-vazio">Sem anexos para o chamado.</p>
            ) : (
                <div className="chamado-sidebar-anexos-lista">
                    <ListaAnexosSolicitante arrayAnexos={anexos} satNum={id} compact />
                </div>
            )}
            <div className="chamado-sidebar-anexos-adicionar">
                <ChamadoAttachmentField
                    id="solicitante-historico-anexo"
                    nomeArquivo={novoAnexoNome}
                    onFileChange={({ base64, nome }) => { setNovoAnexoBase64(base64 || ''); setNovoAnexoNome(nome || ''); }}
                />
                <button type="button" className="btn btn-primary btn-sm" onClick={adicionarAnexoNoCard} disabled={salvandoAnexo || !novoAnexoBase64 || !novoAnexoNome?.trim()}>
                    {salvandoAnexo ? 'Enviando...' : 'Adicionar anexo'}
                </button>
            </div>
        </>
    );

    return (
        <div className="app-layout">
            <SidebarSolicitante />
            <main className="main-content sol-page">
                <Link to="/Solicitante/home" className="sol-back">
                    <i className="fas fa-arrow-left" /> Voltar para meus chamados
                </Link>
                <ChamadoPageSolicitante
                    titulo={`Chamado #${id}`}
                    subtitulo={tipoNome || null}
                    statusNome={statusNome}
                    atendenteNome={atendenteNome || null}
                    tipoNome={tipoNome}
                    descriptionContent={descriptionContent}
                    editorProps={{
                        value: satDesHis,
                        onChange: setSatDesHis,
                        onInserir: updateSatiHistorico,
                        onAnexar: openAnexo,
                        marcado: false,
                        onMarcadoChange: () => {},
                        comentarioInterno: false,
                        onComentarioInternoChange: () => {},
                        onAtualizar: () => { fetchData(); fetchAnexos(); sadDesSolGet(); },
                    }}
                    timelineEventos={timelineEventos}
                    anexosCard={anexosCardContent}
                    anexosCardRef={anexosCardRef}
                />
            </main>
        </div>
    );
}

export default HistoricoSatiSolicitante;
